import ListingLaunchPad from './ListingLaunchPad'
import ListingLaunchPadInterface from './ListingLaunchPad.interface'

interface ListingLaunchPadTypes {
  Interface: (props: any) => JSX.Element
}

const ListingLaunchPadExtended: any & ListingLaunchPadTypes = ListingLaunchPad

ListingLaunchPadExtended.Interface = ListingLaunchPadInterface

export default ListingLaunchPadExtended
